// https://jira.groupondev.com/browse/MIA-150
export const enum Errors {
  incompleteName = 'incompleteName',
  onlyNumbers = 'onlyNumbers',
  tooLong = 'tooLong',
}

export const validateFullName = (firstName: string, lastName: string): string | null => {
  if (!firstName || typeof firstName !== 'string') {
    return Errors.incompleteName;
  }

  if (!lastName || typeof lastName !== 'string') {
    return Errors.incompleteName;
  }

  if (!Number.isNaN(Number(firstName)) || (lastName && !Number.isNaN(Number(lastName)))) {
    return Errors.onlyNumbers;
  }

  if (firstName.length > 64 || (lastName && lastName.length > 64)) {
    return Errors.tooLong;
  }

  return null;
};
